
import { defineComponent, PropType } from "vue";
import * as fb from "../../../firebase";
import { ManualMmiActivationRequest } from "functions/src/MMI/MMIInterfaces";

// Today CMMI has a single chapter. It stays a constant (not a picker) until a
// second one exists — inventing a selector for one value only invites typos.
const CHAPTER = "colombia";

export default defineComponent({
  name: "activate-cmmi",
  props: {
    username: { type: String, required: true },
    subscriptions: {
      type: Object as PropType<Map<string, number>>,
      default: () => new Map(),
    },
  },
  emits: ["cmmiActivated", "error"],
  data() {
    return {
      enabled: false,
      activating: false,
      origin: "transfer" as "transfer" | "grant",
      transferredFrom: "",
      note: "",
    };
  },
  computed: {
    hasCmmi(): boolean {
      // `subscriptions` is a Map<subId, remainingDays> (numbers, NOT objects);
      // active ⟺ the entry exists and remaining days >= 0.
      const remainingDays = this.subscriptions?.get("mmi-" + CHAPTER);
      return typeof remainingDays === "number" && remainingDays >= 0;
    },
    canSubmit(): boolean {
      if (!this.enabled || this.activating) return false;
      if (this.origin === "transfer") return this.transferredFrom !== "";
      return this.note !== "";
    },
  },
  methods: {
    activate() {
      this.activating = true;
      const request: ManualMmiActivationRequest = {
        username: this.username.toLowerCase(),
        chapter: CHAPTER,
        origin: this.origin,
        transferredFrom:
          this.origin === "transfer"
            ? this.transferredFrom.toLowerCase()
            : undefined,
        note: this.note,
      };
      const activateCmmi = fb.func.httpsCallable("Admin-ActivateCmmiManual");
      activateCmmi(request)
        .then((response) => {
          if (response.data.OPCODE == "SUCCESS") {
            this.$emit("cmmiActivated", response.data.data);
            this.transferredFrom = "";
            this.note = "";
            this.enabled = false;
          } else if (response.data.OPCODE == "ERROR") {
            this.$emit(
              "error",
              "Error al activar el Acelerador de Riqueza",
              response.data.message +
                "\n" +
                (response.data.messageDetails || "")
            );
          }
        })
        .catch((error) => {
          this.$emit(
            "error",
            "Error al activar el Acelerador de Riqueza",
            error.message
          );
        })
        .finally(() => {
          this.activating = false;
        });
    },
  },
});
